<template>
  <svg :width="size" :height="size" :fill="color">
    <use :xlink:href="require('@it-enterprise/web-app-common/src/assets/rmd-icons.svg') + `#ICON_${image.toUpperCase()}`"></use>
  </svg>
</template>
<script>
export default {
  props: ['image', 'color', 'size']
}
</script>